import { DataSetHistory } from './data-set-history.js'
import { DataSetHistoryQuery } from './data-set-history-query.js'
import { DataSetHistoryEntitySubscriber } from './event-subscriber.js'

export const entities = [DataSetHistory]
export const resolvers = [DataSetHistoryQuery]
export const subscribers = [DataSetHistoryEntitySubscriber]
